<template>
  <artmisads-modal
    :open="true"
    :title="st('settingsAccountInfo.sectionBillingAddress')"
    :width="720"
    :onCancel="() => props.setShowModal(false)"
    :destroyOnClose="true"
  >
    <a-spin :spinning="spinning">
      <div class="accountInfoModal">
        <div class="item">
          <a-form>
            <a-form-item
              name="contactName"
              v-bind="validateInfos.contactName"
            >
              <div class="input-item">
                <span class="text">{{ st('settingsAccountInfo.formFieldContactName') }}<span>*</span></span>
                <artmisads-input maxlength="100" style="width: 324px;" @blur="() => validate('contactName')" size="middle" v-model:value="modelRef.contactName"/>
              </div>
            </a-form-item>
          </a-form>
          <a-form>
            <a-form-item
              name="country"
              v-bind="validateInfos.country"
            >
              <div class="input-item">
                <span class="text">{{ st('settingsAccountInfo.formFieldCountry') }}<span>*</span></span>
                <artmisads-select
                  v-model:value="modelRef.country"
                  style="width: 324px;"
                  size="middle"
                  :options="props.countryList"
                />
              </div>
            </a-form-item>
          </a-form>
        </div>
        <div class="item">
          <a-form>
            <a-form-item
              name="phone"
              v-bind="validateInfos.phone"
            >
              <div class="input-item phone-item">
                <span class="phone-num">{{props.countryListMap[modelRef.country]?.countryPhoneCode}}</span>
                <span class="text">{{ st('settingsAccountInfo.formFieldPhone') }}<span>*</span></span>
                <artmisads-input maxlength="100" style="width: 324px;" @blur="() => validate('phone')" size="middle" v-model:value="modelRef.phone"/>
              </div>
            </a-form-item>
          </a-form>
          <a-form>
            <a-form-item
              name="email"
              v-bind="validateInfos.email"
            >
              <div class="input-item">
                <span class="text">{{ st('settingsAccountInfo.formFieldEmail') }}<span>*</span></span>
                <artmisads-input maxlength="50" style="width: 324px;" @blur="() => validate('email')" size="middle" v-model:value="modelRef.email"/>
              </div>
            </a-form-item>
          </a-form>
        </div>
        <div class="item">
          <a-form>
            <a-form-item
              name="address"
              v-bind="validateInfos.address"
            >
              <div class="input-item">
                <span class="text">{{ st('settingsAccountInfo.formFieldAddress') }}<span>*</span></span>
                <artmisads-input maxlength="100" style="width: 324px;" @blur="() => validate('address')" size="middle" v-model:value="modelRef.address"/>
              </div>
            </a-form-item>
          </a-form>
          <a-form>
            <a-form-item
              name="addressCont"
              v-bind="validateInfos.addressCont"
            >
              <div class="input-item">
                <span class="text">{{ st('settingsAccountInfo.formFieldAddressCont') }}</span>
                <artmisads-input maxlength="100" style="width: 324px;" @blur="() => validate('addressCont')" size="middle" v-model:value="modelRef.addressCont"/>
              </div>
            </a-form-item>
          </a-form>
        </div>
        <div class="item">
          <a-form>
            <a-form-item
              name="city"
              v-bind="validateInfos.city"
            >
              <div class="input-item">
                <span class="text">{{ st('settingsAccountInfo.formFieldCity') }}<span>*</span></span>
                <artmisads-input maxlength="50" style="width: 324px;" @blur="() => validate('city')" size="middle" v-model:value="modelRef.city"/>
              </div>
            </a-form-item>
          </a-form>
          <a-form>
            <a-form-item
              name="state"
              v-bind="validateInfos.state"
            >
              <div class="input-item">
                <span class="text">{{ st('settingsAccountInfo.formFieldState') }}<span>*</span></span>
                <artmisads-input maxlength="50" style="width: 324px;" @blur="() => validate('state')" size="middle" v-model:value="modelRef.state"/>
              </div>
            </a-form-item>
          </a-form>
        </div>
        <div class="item">
          <a-form>
            <a-form-item
              name="zipCode"
              v-bind="validateInfos.zipCode"
            >
              <div class="input-item">
                <span class="text">{{ st('settingsAccountInfo.formFieldZipCode') }}<span>*</span></span>
                <artmisads-input maxlength="50" style="width: 324px;" @blur="() => validate('zipCode')" size="middle" v-model:value="modelRef.zipCode"/>
              </div>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </a-spin>
    <template #footer>
      <div class="btn">
        <artmisads-button type="primary" @click="sellerBillingAddressSave">{{ st('settingsAccountInfo.btnSave') }}</artmisads-button>
      </div>
    </template>
  </artmisads-modal>
</template>

<script setup>
import { Form } from 'ant-design-vue';
import { ref, reactive } from "vue";
import { connectionApi } from "@/server/seller/index";
import { useUserInfoStore } from '@/storeData/index'
import { CURRENCY_MAPPER } from '@/contants/common'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
const store = useUserInfoStore()
const userInfo = store.userInfo
const props = defineProps(["addressInfo", 'setShowModal', 'countryList', 'countryListMap']);
const spinning = ref(false);

const useForm = Form.useForm;
  const modelRef = reactive({
    contactName: props.addressInfo.contactName,
    country: props.addressInfo.country,
    phone: props.addressInfo.phone,
    email: props.addressInfo.email,
    address: props.addressInfo.address,
    addressCont: props.addressInfo.addressCont,
    city: props.addressInfo.city,
    state: props.addressInfo.state,
    zipCode: props.addressInfo.zipCode,
  });

  const rulesRef = reactive({
    addressCont: [{
      required: false,
    }],
    contactName: [{
      required: true,
      message: st('settingsAccountInfo.validationContactNameRequired'),
      trigger: ['blur']
    }],
    country: [{
      required: true,
      message: st('settingsAccountInfo.validationCountryRequired'),
      trigger: ['blur']
    }],
    phone: [{
      required: true,
      message: st('settingsAccountInfo.validationPhoneRequired'),
      trigger: ['blur']
    }],
    email: [{
      required: true,
      message: st('settingsAccountInfo.validationEmailRequired'),
      trigger: ['blur']
    }],
    address: [{
      required: true,
      message: st('settingsAccountInfo.validationAddressRequired'),
      trigger: ['blur']
    }],
    city: [{
      required: true,
      message: st('settingsAccountInfo.validationCityRequired'),
      trigger: ['blur']
    }],
    state: [{
      required: true,
      message: st('settingsAccountInfo.validationStateRequired'),
      trigger: ['blur']
    }],
    zipCode: [{
      required: true,
      message: st('settingsAccountInfo.validationZipCodeRequired'),
      trigger: ['blur']
    }]
  });

  const { validate, validateInfos } = useForm(modelRef, rulesRef);

const sellerBillingAddressSave = async () => {
  const validateRes = await validate();
  if (!validateRes.errorFields) {
    spinning.value = true;
    let paramsData = validateRes;
    paramsData.marketplace = CURRENCY_MAPPER[userInfo.countryCode].host
    const res = await await connectionApi.sellerBillingAddressSave(paramsData);
    const { success } = res;
    if (success) {
      props.setShowModal(false, true);
    }
    spinning.value = false;
  }
};

</script>

<style lang="less" scoped>
.accountInfoModal {
  padding-bottom: 56px;
  .item {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    &:first-child {
      margin-top: 8px;
    }
    :deep(.ant-form) {
      .input-item {
        display: flex;
        flex-direction: column;
        width: 324px;
        .text {
          color: var(--dark-2);
          font-weight: 500;
          line-height: 18px;
          font-size: 13px;
          margin-bottom: 4px;
          display: flex;
          > span {
            color: var(--red-text);
            margin-left: 3px;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
          }
        }
      }
      .phone-item {
        position: relative;
        input {
          padding-left: 50px;
        }
        .phone-num {
          position: absolute;
          left: 10px;
          top: 23px;
          z-index: 1;
          font-size: 13px;
          font-weight: 500;
          line-height: 32px;
          color: var(--dark-2);
          letter-spacing: 0.4px;
        }
      }
      .ant-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
